import { Dispatch } from 'redux';
import { OrderedMap } from 'immutable';
import { isNullOrUndefined } from 'util';
import { Moment } from 'moment';

import { fetcher } from '../../lib/request';
import { Compilation } from '../../models/Afisha/Compilation';
import { Event } from '../../models/Afisha/Event';
import Genre from '../../models/Afisha/Genre';
import { Place } from '../../models/Afisha/Place';
import { Category } from '../../models/Afisha/Category';

const AFISHA_HOST = process.env.REACT_APP_AFISHA_HOST;
const AFISHA_KEY = process.env.REACT_APP_AFISHA_KEY;

export const GET_COMPILATIONS_REQUEST = 'AFISHA_GET_COMPILATIONS_REQUEST';
export const GET_COMPILATIONS_RESPONSE = 'AFISHA_GET_COMPILATIONS_RESPONSE';
export const GET_COMPILATIONS_ERROR = 'AFISHA_GET_COMPILATIONS_ERROR';

export const GET_COMPILATION_EVENTS_REQUEST = 'AFISHA_GET_COMPILATION_EVENTS_REQUEST';
export const GET_COMPILATION_EVENTS_RESPONSE = 'AFISHA_GET_COMPILATION_EVENTS_RESPONSE';
export const GET_COMPILATION_EVENTS_ERROR = 'AFISHA_GET_COMPILATION_EVENTS_ERROR';

export const GET_MORE_COMPILATION_EVENTS_RESPONSE = 'AFISHA_GET_MORE_COMPILATION_EVENTS_RESPONSE';

export const GET_COMPILATION_PLACES_REQUEST = 'AFISHA_GET_COMPILATION_PLACES_REQUEST';
export const GET_COMPILATION_PLACES_RESPONSE = 'AFISHA_GET_COMPILATION_PLACES_RESPONSE';
export const GET_COMPILATION_PLACES_ERROR = 'AFISHA_GET_COMPILATION_PLACES_ERROR';

export const GET_MORE_COMPILATION_PLACES_RESPONSE = 'AFISHA_GET_MORE_COMPILATION_PLACES_RESPONSE';

export const RESET_EVENTS = 'AFISHA_RESET_EVENTS';
export const RESET_PLACES = 'AFISHA_RESET_PLACES';

export const SEARCH_EVENTS_REQUEST = 'AFISHA_SEARCH_EVENTS_REQUEST';
export const SEARCH_EVENTS_RESPONSE = 'AFISHA_SEARCH_EVENTS_RESPONSE';
export const SEARCH_EVENTS_ERROR = 'AFISHA_SEARCH_EVENTS_ERROR';

export const SET_EVENT_QUERY = 'AFISHA_SET_EVENT_QUERY';

export const SEARCH_PLACES_REQUEST = 'AFISHA_SEARCH_PLACES_REQUEST';
export const SEARCH_PLACES_RESPONSE = 'AFISHA_SEARCH_PLACES_RESPONSE';
export const SEARCH_PLACES_ERROR = 'AFISHA_SEARCH_PLACES_ERROR';

export const SET_PLACE_QUERY = 'AFISHA_SET_PLACE_QUERY';

interface CompilationsResponse {
    result: Compilation[];
    error: any;
}

interface EventsResponse {
    result: {
        events: Event[];
        pagination: any;
    };
    error: any;
}

interface PlacesResponse {
    result: {
        places: Place[];
    };
    error: any;
}

export const getCompilationsAction = (cityId: number, tariffId: number, dateFrom: Moment, dateTo: Moment | null = null, lang: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COMPILATIONS_REQUEST,
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher<CompilationsResponse>(`${AFISHA_HOST}/api/v3/compilations?city_id=${cityId}&tariff_id=${tariffId}&lang=${lang}${dates}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_COMPILATIONS_RESPONSE,
            response,
        });
    } catch (e) {
        dispatch({
            type: GET_COMPILATIONS_ERROR,
            e,
        });
    }
};

export const getCompilationEventsAction = (
    compilationName: string,
    cityId: number,
    order: string,
    ageRestriction: number | null,
    genres: OrderedMap<number, Genre>,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {

    dispatch({
        type: GET_COMPILATION_EVENTS_REQUEST,
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        let genresQuery: string = '';
        if (genres) {
            for (let genre of genres.valueSeq().toArray()) {
                console.log(genre);
                genresQuery += '&genres[]=' + genre.id;
            }
        }
        const ageQuery = !isNullOrUndefined(ageRestriction) ? `&age_restriction=${ageRestriction}` : '';
        const response = await fetcher<EventsResponse>(`${AFISHA_HOST}/api/v3/events/compilations/${compilationName}?city_id=${cityId}${dates}&lang=${lang}` +
            `&compilation_name=${compilationName}${genresQuery}${ageQuery}&order=${order}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_COMPILATION_EVENTS_RESPONSE,
            response,
        });
    } catch (e) {
        dispatch({
            type: GET_COMPILATION_EVENTS_ERROR,
            e,
        });
    }
};

export const getMoreCompilationEventsAction = (
    compilationName: string,
    cityId: number,
    page: number,
    order: string,
    ageRestriction: number | null,
    genres: OrderedMap<number, Genre>,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COMPILATION_EVENTS_REQUEST
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        // const genresQuery = genres.size ? `genres=${genres.reduce((prev, cur) => prev!.concat(`,${cur!.id}`), '')}` : '';
        const genresQuery = genres.size ? genres.valueSeq().toArray().map(genre => `genre[]=${genre.id}`) : '';
        const ageQuery = !isNullOrUndefined(ageRestriction) ? `&age_restriction=${ageRestriction}` : '';

        const response = await fetcher<EventsResponse>(`${AFISHA_HOST}/api/v3/events/compilations/${compilationName}?city_id=${cityId}${dates}` +
            `&page=${page}&lang=${lang}&per=25&order=${order}${ageQuery}&${genresQuery}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_COMPILATION_EVENTS_RESPONSE,
            response,
        });
    } catch (e) {
        dispatch({
            type: GET_COMPILATION_EVENTS_ERROR,
            e,
        });
    }
};

export const getCompilationPlacesAction = (
    compilation: string,
    city: number,
    categories: Category[],
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COMPILATION_PLACES_REQUEST
    });

    try {
        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        const categoriesQuery = categories.map((category) => `&categories[]=${category.id}`);

        const response = await fetcher<PlacesResponse>(`${AFISHA_HOST}/api/v3/places/compilations/${compilation}?` +
            `city_id=${city}${dates}&per=25&page=1&lang=${lang}${categoriesQuery}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_COMPILATION_PLACES_RESPONSE,
            response
        });
    } catch (e) {
        dispatch({
            type: GET_COMPILATION_PLACES_ERROR,
            error: e
        });
    }
};

export const getMoreCompilationPlacesAction = (
    compilation: string,
    city: number,
    page: number,
    categories: Category[],
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COMPILATION_PLACES_REQUEST
    });

    const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
    const categoriesQuery = categories.map((category) => `&categories[]=${category.id}`);

    try {
        if (!lang) {
            lang = 'ru';
        }

        const response = await fetcher<PlacesResponse>(`${AFISHA_HOST}/api/v3/places/compilations/${compilation}?` +
            `city_id=${city}&page=${page}&per=25&${categoriesQuery}${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: GET_MORE_COMPILATION_PLACES_RESPONSE,
            response
        });
    } catch (e) {
        dispatch({
            type: GET_COMPILATION_PLACES_ERROR,
            error: e
        });
    }
};

export const resetEventsAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_EVENTS
    });
};

export const resetPlacesAction = () => (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_PLACES
    });
};

export const searchEventsAction = (
    cityId: number,
    query: string,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string,
    compilationName?: string,
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SEARCH_EVENTS_REQUEST,
    });

    try {
        if (!lang) {
            lang = 'ru';
        }

        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;
        const compilation = compilationName ? `&compilation_name=${compilationName}` : '';

        const response = await fetcher<EventsResponse>(`${AFISHA_HOST}/api/v3/events?city_id=${cityId}&q=${query}` +
            `${dates}${compilation}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: SEARCH_EVENTS_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: SEARCH_EVENTS_ERROR,
            error,
        });
    }
};

export const setEventQueryAction = (query: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_EVENT_QUERY,
    query,
});

export const searchPlacesAction = (
    cityId: number,
    query: string,
    dateFrom: Moment,
    dateTo: Moment | null = null,
    lang: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SEARCH_PLACES_REQUEST,
    });

    try {
        const dates = `&date_from=${dateFrom.format('YYYY-MM-DD HH:mm:ss')}${dateTo ? `&date_to=${dateTo.format('YYYY-MM-DD HH:mm:ss')}` : ''}`;

        const response = await fetcher<PlacesResponse>(`${AFISHA_HOST}/api/v3/places?city_id=${cityId}` +
            `&q=${query}${dates}&lang=${lang}`)
            .auth(`Basic ${AFISHA_KEY}`)
            .json();

        dispatch({
            type: SEARCH_PLACES_RESPONSE,
            response,
        });
    } catch (error) {
        dispatch({
            type: SEARCH_PLACES_ERROR,
            error,
        });
    }
};

export const setPlaceQueryAction = (query: string) => (dispatch: Dispatch<any>) => dispatch({
    type: SET_PLACE_QUERY,
    query,
});



// WEBPACK FOOTER //
// ./src/actions/Afisha/compilation.ts